export class PersonalsAccidentsRiskData {
    isMotorcycle: boolean;
    insuredGroupMembersQuantity: number;
    riskCategoryId: number;
    riskCategoryDescription: string;
    coverageType: string;
}
